import CAButton from '@ds/components/buttons/CAButton'
import CAAlert from '@ds/components/notifications/CAAlert'
import GlobalStore from '@vuejs/stores/GlobalStore'
import { defineComponent } from 'vue'

import t from '@/javascript/lib/i18next'

export default defineComponent({
	name: 'NoResultsFoundPlaceholder',

	props: {
		additionalClasses: { default: '', type: String },
		buttonText: { default: '', type: String },
		dataTest: { default: '', type: String },
		href: { default: '', type: String },
		isDisabled: { default: false, type: Boolean },
		isLoading: { default: false, type: Boolean },
		showButton: { default: true, type: Boolean },
		text: { default: '', type: String },
		title: { default: t('global.noItems'), type: String },
		triggerSidebarWidget: { default: false, type: Boolean },
		useActionSlot: { default: true, type: Boolean },
	},

	emits: ['click'],

	computed: {
		noAction(): boolean {
			return !this.href && !this.$attrs.onClick
		},
	},

	methods: {
		onHandleClick() {
			if (this.triggerSidebarWidget) {
				GlobalStore.emittedEvent === 'show-sidebar-courses'
				this.$emit('click')

				return
			}

			!!this.href ? window.location.assign(this.href) : this.$emit('click')
		},
	},

	render() {
		return (
			<CAAlert
				class={[
					'ca-alert--no-results-found',
					`ca-alert--${!this.useActionSlot ? 'no-slot' : 'with-slot'}`,
				]}
				dataTest={this.dataTest}
				title={this.title}
				type="help"
			>
				{{
					actions: () =>
						this.buttonText && <CAButton
							buttonStyle="text"
							class={[
								`${!this.useActionSlot ? 'mt-2' : ''}`,
								this.additionalClasses,
							]}
							dataTest="placeholder-action-button"
							disabled={this.isDisabled}
							loading={this.isLoading}
							size="compact"
							text={this.buttonText}
							type="primary"
							onClick={this.onHandleClick}
						/>,

					default: () => this.text,
				}}
			</CAAlert>
		)
	},
})
